/**
 * angular imports
 */
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
/**
 * rxjs imports
 */
import { Subscription } from 'rxjs';
/**
 * service imports
 */
import { GetService } from 'src/app/dataservices/get.service';

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss']
})
export class DropDownComponent implements OnInit {

  /**
   * string for label
   */
  @Input() label: string;
  /**
   * formcontrol name
   */
  @Input() formControlName: string;

  @Input() placeholder: string;
  @Input() suggestionList = [];
  @Input() keyValue: string;

  @Input() callApiUrlForList  = true;
  @Input() apiUrl: string;

  @Input() selectedValue: string;

  @Input() isInerrorState = false;

  @Input() mandatory=false;

  /**
   * 
   * emiting event for focus
   */
  @Output() elementTouched: EventEmitter<null> =  new EventEmitter(); 


  /**
   * Used to emit the selected value.
   */
  @Output() emitSelectedValue: EventEmitter<string> = new EventEmitter();
  /**
    * for api subscription
    */
  private subscriptions: Subscription = new Subscription();

  constructor(public getService: GetService,  public chg: ChangeDetectorRef) {

  }
    ngOnInit(): void {
        this.getSearchList('');
    }
  
    getSearchList(query = ''): any {
          this.subscriptions.add( this.getService.getSearchDataForDropDown(this.apiUrl + query).subscribe(data => { 
        if (data) {
          this.suggestionList = data.lc;
          this.chg.detectChanges();
          this.chg.markForCheck();
        }
       }));
   }

   elementFocused(): void {
    this.elementTouched.emit();
  } 
onSelect(event): void {
    this.emitSelectedValue.emit(event.value)
}
}
